<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    No Nap
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.name`]="{ item }">
        <a @click="viewDrawDetail(item)">{{ item.name }}</a>
      </template> -->

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <!-- <template v-slot:[`item.actions`]="{ item }">
        <v-btn x-small color="pink" dark @click="editDrawDetail(item)">
          Edit</v-btn
        >
      </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },
      table: {
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Date",
            align: "start",
            sortable: false,
            value: "createdDate",
            formatter: (x) => (x ? moment(x).format("MMMM DD, YYYY") : null),
          },
          {
            text: "City",
            align: "start",
            value: "city",
          },
          {
            text: "Subscriber Name",
            align: "start",
            value: "name",
          },
          {
            text: "Paid",
            align: "center",
            value: "isPaid",
          },
          {
            text: "Acquirer",
            align: "start",
            value: "acquirer",
            sortable: false,
          },
          {
            text: "Territory Head",
            align: "start",
            value: "territoryHead",
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=no-nap")
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    viewDrawDetail(data) {
      this.$store.dispatch("addDrawDetails", data);
      this.$router
        .push({ path: `${this.$route.matched[0].path}/draw/view/${data.id}` })
        .catch(() => {});
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
